import { render } from "./AutomationDetail.vue?vue&type=template&id=577557f6&scoped=true&ts=true"
import script from "./AutomationDetail.vue?vue&type=script&lang=ts"
export * from "./AutomationDetail.vue?vue&type=script&lang=ts"

import "./AutomationDetail.vue?vue&type=style&index=0&id=577557f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577557f6"]])

export default __exports__